module.exports = __webpack_public_path__ + "assets/bee2a190dc5c224a458aa17bff923789.mp3";